module.exports = __webpack_public_path__ + "static/media/chickenPlate.e79b228f.png";